module.exports = __webpack_public_path__ + "static/media/fill.f849d65d.svg";